//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'base-tooltip',
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
    bottom: {
      type: Boolean,
      default: true,
    },
    offset: {
      type: Number,
      default: 25,
    },
    fixOnClick: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return { isOpen: false };
  },
  methods: {
    triggerClick () {
      if (!this.visible) return;
      event.stopPropagation();
      this.show();
    },
    show () {
      if (this.isMobile) {
        this.isOpen = true;
        return;
      }
      this.$refs.tooltip.isOutsideShowed = true;
    },
    hide () {
      if (this.isMobile) {
        this.isOpen = false;
        return;
      }
      this.$refs.tooltip.isOutsideShowed = false;
    },
    switchShow () {
      if (this.isMobile) {
        this.isOpen = !this.isOpen;
        return;
      }
      if (this.$refs.tooltip.isOutsideShowed) this.hide();
      else this.show();
    },
  },
};
